module.exports = __webpack_public_path__ + "img/summary-shortlisted-count.ee5deb72.svg";